import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom'
import classNames from 'classnames';
import withTranslations from '../../translations';

import { logout } from '../../actions/authentication';
import { logoutPath } from '../../constants/urls';

import {
  Avatar,
  Divider,
  Menu,
  MenuItem,
  Typography,
} from '../base';

import { menuItems } from './constants';

const styles = theme => ({
  avatar: {
    cursor: 'pointer',
    fontSize: theme.typography.caption.fontSize,
  },
  menu: {
    '&>div+div': {
      top: `${theme.spacing(8)}px !important`,
    },

    '& ul': {
      padding: 0,
    },
  },
  menuUsername: {
    padding: theme.spacing(2),

    '&:focus': {
      outline: 'none',
    }
  },
  menuListItem: {
    padding: theme.spacing(),

    [theme.breakpoints.up('sm')]: {
      minWidth: 150,
    },
  },
  link: {
    display: 'flex',
    alignItems: 'center',
    color: 'inherit',
    textDecoration: 'none',
    width: '100%',

    '&:active': {
      color: 'inherit'
    }
  },
  icon: {
    marginRight: theme.spacing(),
  },
});

class AppMenu extends PureComponent {
  state = {
    anchorEl: null,
  }

  handleMenu = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleNavigation = path => {
    if (path === logoutPath()) {
      this.props.history.push(path);
      this.props.actions.logout();
    }

    if (path !== this.props.history.location.pathname) {
      this.props.history.push(path);
      this.handleClose();
    }
  }

  render() {
    const { classes, user, gt } = this.props,
          { anchorEl } = this.state,
          open = Boolean(anchorEl),
          firstName = user && user.firstName,
          lastName = user && user.lastName,
          name = `${firstName} ${lastName}`;

    return (
      <div className='fars-app-menu'>
        <Avatar onClick={this.handleMenu} user={name} className={classes.avatar} />
        <Menu
          className={classes.menu}
          id="menu-appbar"
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          getContentAnchorEl={null}
          open={open}
          onClose={this.handleClose}
        >
          <li>
            <Typography
              className={classes.menuUsername}
              variant='subtitle1'
            >
              { name }
            </Typography>
          </li>
          <Divider />
          { menuItems(gt).map(item =>
              <MenuItem onClick={() => this.handleNavigation(item.path)} key={item.displayName} className={classes.menuListItem}>
                <span className={classes.link}>
                  <i className={classNames("material-icons", classes.icon)}>
                    {item.icon}
                  </i>
                  {item.displayName}
                </span>
              </MenuItem>
            )
          }
        </Menu>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actions: {
    logout: bindActionCreators(logout, dispatch),
  },
})

AppMenu.defaultProps = {
  handleMenu: () => {},
  handleClose: () => {},
  anchorEl: null,
  open: false,
  user: null,
};

AppMenu.propTypes = {
  handleMenu: PropTypes.func,
  handleClose: PropTypes.func,
  anchorEl: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.node,
  ]),
  open: PropTypes.bool,
  user: PropTypes.object,
}

export default withRouter(withStyles(styles)(connect(null, mapDispatchToProps)(withTranslations(AppMenu, 'Global'))));



// WEBPACK FOOTER //
// ./src/components/AppMenu/AppMenu.js